import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { AgeGroupByGenderProps } from '../../../../../services/descriptiveAnalysisReport/descriptiveAnalysis';

interface AgeGroupByGenderBarProps {
  data: AgeGroupByGenderProps[];
}

const AgeGroupByGenderBar: React.FC<AgeGroupByGenderBarProps> = ({ data }) => {
  const formatTooltipValue = (value: number) => {
    return value.toLocaleString('pt-BR');
  };

  const formatLabel = (label: string) => {
    return `Faixa Etária: ${label}`;
  };

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-300 rounded shadow-lg">
          <p className="font-medium">{formatLabel(label)}</p>
          {payload.map((entry: any) => (
            <p key={entry.dataKey} style={{ color: entry.color }}>
              {entry.dataKey === 'masculino' ? 'Masculino' : 'Feminino'}:{' '}
              {formatTooltipValue(entry.value)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  const dynamicHeight = Math.max(400, data.length * 40 + 100);

  return (
    <ResponsiveContainer width="100%" height={dynamicHeight}>
      <BarChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 60,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="description"
          angle={-45}
          textAnchor="end"
          height={80}
          interval={0}
          fontSize={12}
        />
        <YAxis
          tickFormatter={value => value.toLocaleString('pt-BR')}
          fontSize={12}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend
          wrapperStyle={{ paddingTop: '20px' }}
          formatter={value =>
            value === 'masculino' ? 'Masculino' : 'Feminino'
          }
        />
        <Bar
          dataKey="masculino"
          fill="#d3adf7"
          name="masculino"
          radius={[2, 2, 0, 0]}
        />
        <Bar
          dataKey="feminino"
          fill="#9254de"
          name="feminino"
          radius={[2, 2, 0, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default AgeGroupByGenderBar;
